export { BasePortalHost, ComponentPortal } from './portal/portal';
export { Overlay } from './overlay/overlay';
export { OverlayContainer } from './overlay/overlay-container';
export { ToastContainerModule, ToastContainerDirective } from './toast-directive';
export { OverlayRef } from './overlay/overlay-ref';
export { Toast } from './toast-component';
export { ToastrService } from './toastr-service';
export { ToastrConfig, ToastConfig, ToastData } from './toastr-config';
export { ToastrModule } from './toastr-module';
export { ToastRef } from './toast-injector';



//////////////////
// WEBPACK FOOTER
// ./~/ngx-toastr/toastr.js
// module id = 198
// module chunks = 4